import { useEffect } from 'react';
import useContentFeed from '../../common/use-content-feed';
import Feed from '../../components/feed';
import { DEFAULT_SKIP_TO_CONTENT_ID } from '../../components/skip-to-content/skip-to-content';

const ProfileSubmitted = ({ profileId, analyticsData }) => {
  const { fetching, feedItems, page, canLoadMore, fetchFeed } = useContentFeed({
    advocateId: profileId,
    advocateFilter: 'submitted',
  });

  const analyticsDataFeed = {
    ...analyticsData,
    location: 'profile_submitted',
  };

  // get rid of this when recoil is migrated to react-query
  // and we can invalidate the feed query in an elegant way
  // when user modifies their submitted content
  useEffect(() => {
    fetchFeed(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileId]);

  return (
    <div className="user-profile-submitted" id={DEFAULT_SKIP_TO_CONTENT_ID}>
      <Feed
        items={feedItems}
        page={page}
        fetching={fetching}
        canLoadMore={canLoadMore}
        fetchFeed={fetchFeed}
        analyticsData={analyticsDataFeed}
      />
    </div>
  );
};

export default ProfileSubmitted;
